import { Box, Grid, Stack, Typography } from "@mui/material";
import { FormField } from "@/components/elements/FormField";
import { divider, black } from "@/theme/colors";
import { InnerBox } from "@/components/elements/InnerBox";
import { useFormContext } from "react-hook-form";
import { SelectMulti } from "@/components/elements/SelectMulti";
import { TTalentForm } from "@/features/talent/types/talentForm";
import { Input } from "@/components/elements/Input";
import { Textarea } from "@/components/elements/Textarea";
import { useGetCompanySpecificIndustryList } from "@/api/services/global/master";

export const TalentFormJobPreferences = () => {
  const methods = useFormContext<TTalentForm>();
  const { control } = methods;
  const { companySpecificIndustryOptions } = useGetCompanySpecificIndustryList();

  return (
    <InnerBox p={3} showDivider={false} borderColor={divider.high} bordered={true}>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box flex={1}>
          <Typography variant="head20Bold" color={black[30]}>
            希望条件
          </Typography>
        </Box>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="desiredJobTypeIds">
              <SelectMulti placeholder="選択してください" options={companySpecificIndustryOptions} />
            </FormField>
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="desiredWorkLocation">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="expectSalary">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="availableFrom">
              <Input placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>

      <Stack mt={2}>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <FormField control={control} name="otherRequest">
              <Textarea placeholder="入力してください" />
            </FormField>
          </Grid>
        </Grid>
      </Stack>
    </InnerBox>
  );
};
